import React from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import FacebookShare from "../FacebookShare";

import "./Footer.css";

const Footer = () => {
  return(
    <Navbar fixedBottom>
      <Nav pullRight>
        <NavItem className="fb-button-container pull-right">
          <FacebookShare />
        </NavItem>
        <NavItem className="pinterest-button pull-right"
          data-pin-do="buttonBookmark"
          data-pin-tall="true"
          data-pin-save="true"
          href="https://www.pinterest.com/pin/create/button/">
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer/Footer.js
 **/